export default __webpack_public_path__ + "static/media/330_portfolio04-it-web.d0068a47.png";